<template>
	<div class="wrapper">
		<vx-card title="Restant" icon="icon-chart">
			<div class="flex items -center justify-center">
				<div class="text-center mb-4">
					<h5 class="mb-2">Data For Seo</h5>
					<h3 class="text-primary">
						{{ convertNumberToFrenchCurrency(dfsBalance) }}
					</h3>
				</div>
			</div>
		</vx-card>

		<vs-table
			max-items="200"
			pagination
			:data="allcost"
			noDataText="Aucun(e) Consultant Lead sélectionné(e)."
		>
			<template slot="thead">
				<vs-th
					class="text-center"
					style="pointer-events: auto"
					sort-key="created_date"
					>Date</vs-th
				>
				<vs-th
					class="text-center"
					style="pointer-events: auto"
					sort-key="service_name"
					>Service</vs-th
				>
				<vs-th class="text-center" style="pointer-events: auto" sort-key="cost"
					>Cost</vs-th
				>
			</template>
			<template slot-scope="{ data }">
				<vs-tr
					:data="data[indextr]"
					:key="indextr"
					v-for="(tr, indextr) in data"
				>
					<vs-td class="text-left">{{
						fromatDate(data[indextr].created_date)
					}}</vs-td>
					<vs-td class="text-left">{{ data[indextr].service_name }}</vs-td>
					<vs-td class="text-left">{{ data[indextr].cost }}</vs-td>
				</vs-tr>
			</template>
		</vs-table>
	</div>
</template>
  
  <script>
import utilsMixin from "../../mixins/utilsMixin";
import moment from "moment";
export default {
	name: "ApiCosts",
	data() {
		return {
			dfsBalance: "",
			allcost: [],
			title: "Hello, Vue!",
			message: "This is a simple Vue.js component.",
		};
	},
	mixins: [utilsMixin],
	created() {
		this.fetchDfsUser();
		this.fetchAllCosts();
	},
	methods: {
		fromatDate(date) {
			return moment(date).format("DD/MM/YYYY HH:mm:ss");
		},
		fetchDfsUser() {
			this.$http
				.get(`/dataforseo/getUser`)
				.then((response) => {
					this.dfsBalance = response.data["money"]["balance"];
				})
				.catch((err) => {
					console.log(err);
				});
		},
		fetchAllCosts() {
			this.$http
				.get(`others/api/totalCosts`)
				.then((response) => {
					this.allcost = response.data;
				})
				.catch((err) => {
					console.log(err);
				});
		},
	},
};
</script>
  
  <style scoped>
.wrapper {
	text-align: center;
}
</style>